import { TableColumnMeta } from "ds/components/Table/types";
import { ScanProvider, SearchQueryOrderDirection } from "types/generated";

export const SCANS_COLUMNS_STORAGE_KEY = "scansColumnsConfig";
export const SCANS_FILTERS_ORDER_KEY = "scansFiltersOrder";
export const SCANS_LIMIT = 25;
export const SCANS_LIMIT_STORAGE_KEY = "scansLimit";
export const SCANS_PAGINATION_OPTIONS = [25, 50];
export const SCANS_INITIAL_SORT_OPTION = "name";
export const SCANS_INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;

export enum SCANS_COLUMN_ID {
  NAME = "NAME",
  STATUS = "STATUS",
  UNMANAGED_RESOURCES = "UNMANAGED_RESOURCES",
  PROVIDER = "PROVIDER",
  LABELS = "LABELS",
  LAST_SCAN = "LAST_SCAN",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 1200;

export const SCANS_COLUMN_CONFIG: Record<SCANS_COLUMN_ID, TableColumnMeta> = {
  [SCANS_COLUMN_ID.NAME]: {
    id: SCANS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: false,
    configurable: true,
  },
  [SCANS_COLUMN_ID.STATUS]: {
    id: SCANS_COLUMN_ID.STATUS,
    title: "Status",
    minWidth: 120,
    defaultWidth: 160,
    maxWidth: 240,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    configurable: true,
  },
  [SCANS_COLUMN_ID.UNMANAGED_RESOURCES]: {
    id: SCANS_COLUMN_ID.UNMANAGED_RESOURCES,
    title: "Unmanaged resources",
    minWidth: 180,
    defaultWidth: 200,
    maxWidth: 280,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    configurable: true,
  },
  [SCANS_COLUMN_ID.PROVIDER]: {
    id: SCANS_COLUMN_ID.PROVIDER,
    title: "Providers",
    minWidth: 120,
    defaultWidth: 160,
    maxWidth: 240,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    configurable: true,
  },
  [SCANS_COLUMN_ID.LABELS]: {
    id: SCANS_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 120,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    configurable: true,
  },
  [SCANS_COLUMN_ID.LAST_SCAN]: {
    id: SCANS_COLUMN_ID.LAST_SCAN,
    title: "Last scan",
    minWidth: 140,
    defaultWidth: 200,
    maxWidth: 280,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    configurable: true,
  },
  [SCANS_COLUMN_ID.DROPDOWN]: {
    id: SCANS_COLUMN_ID.DROPDOWN,
    title: "Scan actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const SCANS_SORT_CONFIG: Partial<Record<SCANS_COLUMN_ID, string>> = {
  [SCANS_COLUMN_ID.NAME]: SCANS_INITIAL_SORT_OPTION,
};

export const SCAN_PROVIDER_LABEL: Record<ScanProvider, string> = {
  [ScanProvider.Aws]: "AWS",
};
